export const FETCH_ALL_BOARDS = 'analytics/FETCH_ALL_BOARDS';
